import { createFeatureSelector, createSelector } from '@ngrx/store'
import * as reducer from './shared-content.reducer'
import * as state from './shared-content.state'

export const sharedContentState = createFeatureSelector<state.State>('shared-content')

export const selectAllSharedContent = createSelector(sharedContentState, reducer.selectAll)

export const selectSharedContentLoaded = createSelector(sharedContentState, (s: state.State) => s.isLoaded)
